/**
 * RESPONSIBILITY: draw the people to ask about an event.
 *
 * The photograph is the point. A name and a role is contact information; a face is an
 * invitation, and this band exists on every church site worth copying for that reason.
 */
import { idOf } from '@framework/core';
import { THEME } from '@app/sections';
import { Band } from './Band';
import { Picture } from '../../commons/Picture';
import type { BandProps } from './kind';

export function Contacts({ s }: BandProps) {
  const people = (s.contacts ?? []).filter((p) => p.name);
  if (!people.length) return null;

  return (
    <Band theme={THEME.Contacts} heading={s.heading || 'Have questions?'}>
      <ul className="ev-people">
        {people.map((p) => (
          <li key={idOf(p)} className="ev-person">
            <Picture value={p.photo} alt={p.name} className="ev-face" />
            <span className="ev-name">{p.href ? <a href={p.href}>{p.name}</a> : p.name}</span>
            {p.role ? <span className="ev-role">{p.role}</span> : null}
          </li>
        ))}
      </ul>
    </Band>
  );
}
